import React from 'react';
import { useSelector } from 'react-redux';
import FeedbackCard from '@src/components/FeedbackCard';
import { selectors } from '@src/containers/ProfileVenue';
import AvatarRoundFeed from '@src/components/AvatarRound/set/AvatarRoundFeed';
import PopoverShareCDefault from '@src/components/PopoverShare/connectors/default';

const FeedbacksListCVenueProfile = () => {
	const reviews = useSelector(selectors.profileReviewsMapped);

	return (
		<>
			{reviews.map((review) => {
				return (
					<FeedbackCard
						key={review.id}
						{...review}
						AvatarRound={AvatarRoundFeed}
						PopoverShare={
							review.shareLink ? PopoverShareCDefault : undefined
						}
					/>
				);
			})}
		</>
	);
};

export default FeedbacksListCVenueProfile;
